/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";
import { ContentContext } from "context/contentContext";

/**
 * import components
 */

/**
 * styled components
 */
const Container = styled.div`
  ${t.mixins.flex({ justify: "flex-start" })}
  margin-bottom: 34px;
  cursor: pointer;

  ${t.mixins.sm(`
    margin-bottom: 28px;
    padding: 0 26px;
  `)}
`;
const Image = styled.img.attrs({ src: t.image.back })`
  height: 15px;
  width: 12px;
  margin-right: 7px;
`;
const Title = styled.p`
    ${t.mixins.rem(13, 17)}
    font-family: ${t.font.primary};
    font-weight: ${t.font.bold};
    color: ${t.color.blue};
    text-transform: uppercase;
  `;

/**
 * back component is..
 */

const Button__back = ({ onClick, title, className }) => {
  const { c } = useContext(ContentContext);
  return (
    <Container onClick={onClick} className={className}>
      <Image />
      <Title>{c('home.form.back')} {title}</Title>
    </Container>
  );
};

export default Button__back;

Button__back.propTypes = {
  /**
      A custom style object
      */
  title: PropTypes.string,
};

Button__back.defaultProps = {
  title: "",
};

/*
    import Button__back from 'components/form/back/Button__back'
    <Button__back />
  */
